import React, { useState } from "react";
import { Layout } from "antd";
import LayoutMenu from "../components/LayoutMenu";
import LayoutHeader from "../components/LayoutHeader";

import styles from "./DashboardLayout.module.css";

const { Header, Sider, Content } = Layout;

function DashboardLayout(props: any) {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <>
            <Layout className={styles.layout}>
                <Header className={styles.header}>
                    <LayoutHeader />
                </Header>
                <Layout>
                    <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
                        <LayoutMenu />
                    </Sider>
                    <Content>{props.children}</Content>
                </Layout>
            </Layout>
        </>
    );
}

export default DashboardLayout;
